import { H3, useDialog } from '@wheely/ui-kit';
import { useCallback, useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from '@src-common/view/adapters/Button';
import { SelectField } from '@src-common/view/adapters/SelectField';
import { TextField } from '@src-common/view/adapters/TextField';
import { TListItems } from '@src-common/view/components/ListInput';

import s from './Blocking.module.css';

interface IProps {
  onBlock(reason: string, details: string): void;
}

const Blocking = ({ onBlock }: IProps) => {
  const intl = useIntl();
  const options = useMemo<TListItems>(
    () => [
      {
        title: intl.formatMessage({
          defaultMessage: 'Temporarily blocked by the partner',
          id: 'SzHk1F',
          description: 'driver block reason select option',
        }),
        value: 'Temporarily blocked by the partner',
      },
      {
        title: intl.formatMessage({
          defaultMessage: 'Fired by the partner',
          id: 'uq/F0T',
          description: 'driver block reason select option',
        }),
        value: 'Fired by the partner',
      },
      {
        title: intl.formatMessage({
          defaultMessage: 'Fraudster',
          id: '2Ea+3e',
          description: 'driver block reason select option',
        }),
        value: 'Fraudster',
      },
      {
        title: intl.formatMessage({
          defaultMessage: 'Other',
          id: 'XvRFUa',
          description: 'driver block reason select option',
        }),
        value: 'Other',
      },
    ],
    [intl],
  );

  const [values, setValues] = useState({ reason: '', message: '' });
  const handleChange = useCallback(
    (_: unknown, { value, name }: { value: string; name: string }) => {
      setValues(current => ({ ...current, [name]: value }));
    },
    [],
  );

  const handleBlock = useCallback(() => {
    onBlock(values.reason, values.message);
  }, [onBlock, values.message, values.reason]);

  return (
    <div className={s.root}>
      <SelectField
        title={
          <FormattedMessage
            defaultMessage="Reason"
            id="ljHwP6"
            description="Modal dialog input title"
          />
        }
        items={options}
        value={values.reason}
        name={'reason'}
        onChange={handleChange}
      />
      <TextField
        title={
          <FormattedMessage
            defaultMessage="Message"
            id="ieD6Vm"
            description="Modal dialog input title"
          />
        }
        value={values.message}
        name={'message'}
        onChange={handleChange}
        placeholder={
          <FormattedMessage
            defaultMessage="Block reason message"
            id="VC90GT"
            description="Modal dialog placeholder"
          />
        }
      />
      <div className={s.actions}>
        <Button
          onClick={handleBlock}
          intent={'danger'}
          isDisabled={values.reason === '' || values.message === ''}
        >
          <FormattedMessage defaultMessage="Block" id="jkdv4T" description="Modal dialog button" />
        </Button>
      </div>
    </div>
  );
};

const useOpenBlockingModal = () => {
  const { openDialog, closeDialogs } = useDialog();

  const openBlocking = (params: IProps) => {
    openDialog(() => <Blocking onBlock={params.onBlock} />, {
      title: (
        <H3>
          <FormattedMessage
            defaultMessage="Block the chauffeur"
            id="Ob6B6s"
            description="Modal dialog title"
          />
        </H3>
      ),
      bodyClassName: s.dialog,
    });
  };

  return { closeDialogs, openBlocking };
};

export { Blocking, useOpenBlockingModal };
